import { Amplify } from 'aws-amplify';
import { ApiRestService } from './services/api-rest/api-rest.service';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, HammerModule, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from './components/header/header.component';
import { HttpClientModule } from '@angular/common/http';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import { SpecialOfferDialogComponent } from './components/special-offer-dialog/special-offer-dialog.component';
import { SpecialOfferTermDialogComponent } from './components/special-offer-term-dialog/special-offer-term-dialog.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { HistoricalBottomSheetModule } from './components/historical-bottom-sheet/historical-bottom-sheet.module';
import * as Sentry from '@sentry/angular';
import localeEsPE from '@angular/common/locales/es-PE';
registerLocaleData(localeEsPE, 'es-PE');
Amplify.configure({
  API: {
    GraphQL: {
      endpoint: environment.amplify.GraphQL.endpoint,
      region: environment.amplify.GraphQL.region,
      defaultAuthMode: 'apiKey',
      apiKey: environment.amplify.GraphQL.apiKey,
    },
  },
});

@NgModule({
  declarations: [AppComponent, HeaderComponent, SpecialOfferDialogComponent, SpecialOfferTermDialogComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HammerModule,
    HistoricalBottomSheetModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatGridListModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTableModule,
    MatToolbarModule,
    HttpClientModule,
    RouterModule,
    SweetAlert2Module.forRoot(),
  ],
  providers: [
    Title,
    ApiRestService,
    { provide: LOCALE_ID, useValue: 'es-PE' },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private router: Router, private titleService: Title) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.titleService.setTitle('Happyland - Portal Promociones');
      }
    });
  }
}
